import { useEffect, useState } from "react";
import { getSkuSpecs, getSkuMaster } from "../firebase/services";
import { msiStandardSpecs, groupedSpecs } from "../utils/masterSpecs";
import { useLanguage } from "../hooks/useLanguage";

// Thứ tự cột của master hiện tại — dùng chung cho mọi lần mở, chỉ tải một lần
let masterColumnsPromise = null;
const loadMasterColumns = () => {
  if (!masterColumnsPromise) {
    masterColumnsPromise = getSkuMaster().then(m => m?.columns || []).catch(() => { masterColumnsPromise = null; return []; });
  }
  return masterColumnsPromise;
};
export const resetMasterColumnsCache = () => { masterColumnsPromise = null; };

// "Thông số chuẩn MSI" của một SKU (giống trang sản phẩm của web MSI Product Specs),
// kèm phần "Tất cả thông số" theo nhóm. SKU chưa có trong master → hiện fallback (các trường gọn).
export default function SkuSpecSheet({ sku, fallback = null }) {
  const { t, lang } = useLanguage();
  const [state, setState] = useState({ loading: true, values: null, columns: [] });
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setState({ loading: true, values: null, columns: [] });
    setShowAll(false);
    Promise.all([getSkuSpecs(sku?.partNo).catch(() => null), loadMasterColumns()]).then(([spec, columns]) => {
      if (!cancelled) setState({ loading: false, values: spec?.values || null, columns });
    });
    return () => { cancelled = true; };
  }, [sku?.partNo]);

  if (state.loading) return <div style={{ color: "#888", fontSize: 12, padding: "8px 0" }}>{t("common.loading")}</div>;
  if (!state.values) {
    return (
      <>
        <div style={{ fontSize: 11, color: "#999", marginBottom: 6 }}>{t("spec.no_master")}</div>
        {fallback}
      </>
    );
  }

  const L = (label) => label[lang === "vi" ? "vi" : "en"] || label.vi;
  const rows = msiStandardSpecs(state.values, state.columns);
  const groups = showAll ? groupedSpecs(state.values, state.columns) : [];

  return (
    <div className="spec-sheet">
      <div style={{ fontSize: 12, fontWeight: 600, color: "#C8152A", margin: "4px 0 6px" }}>{t("spec.msi_standard")}</div>
      <table style={{ fontSize: 12, width: "100%", borderCollapse: "collapse" }}>
        <tbody>
          {rows.map(r => (
            <tr key={r.id} style={{ borderBottom: "1px solid #f2f2f2" }}>
              <td style={{ color: "#666", width: 110, padding: "5px 8px 5px 0", verticalAlign: "top", fontSize: 11, fontWeight: 500 }}>{L(r.label)}</td>
              <td style={{ padding: "5px 0", wordBreak: "break-word" }}>
                {r.lines.map((line, i) => <div key={i}>{line}</div>)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button type="button" className="btn btn-sm" style={{ marginTop: 10 }} onClick={() => setShowAll(v => !v)}>
        {showAll ? t("spec.hide_all") : t("spec.show_all")}
      </button>
      {showAll && groups.map(g => (
        <div key={g.id} style={{ marginTop: 10 }}>
          <div style={{ fontSize: 11, fontWeight: 600, color: "#444", background: "#f7f7f5", padding: "4px 8px", borderRadius: 4 }}>{L(g.label)}</div>
          <table style={{ fontSize: 11, width: "100%", borderCollapse: "collapse" }}>
            <tbody>
              {g.items.map(it => (
                <tr key={it.column} style={{ borderBottom: "1px solid #f5f5f5" }}>
                  <td style={{ color: "#888", width: "42%", padding: "3px 8px 3px 0", verticalAlign: "top", wordBreak: "break-word" }}>{it.column}</td>
                  <td style={{ padding: "3px 0", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{it.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
